// src\pages\PrivacyPage.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {Container} from 'react-bootstrap';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import PolicySwitcher from '../components/ui/policySwitcher';
import { useTranslation } from 'react-i18next';

const PrivacyContainer = styled(Container)`
  max-width: 800px;
  margin: auto;
  color: #fff;
  border-radius: 8px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const StyledP = styled.p`
  color: #b8b8b8;
  margin-bottom: 0;
`;

const StyledLink = styled.a`
  color: #00aaff;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    color: #ffcc00;
    text-decoration: underline;
  }
`;

const StyledH = styled.h5``;

const SupportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
const SupportEmailMailTo = 'mailto:' + SupportEmail;

const PrivacyPage = () => {
  const { t } = useTranslation();

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('privacyPage.title')} />
      <PolicySwitcher />
      <PrivacyContainer>
        <Section>
          <StyledH>{t('privacyPage.introduction.heading')}</StyledH>
          <StyledP>{t('privacyPage.introduction.text')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.informationCollected.heading')}</StyledH>
          <StyledP>{t('privacyPage.informationCollected.accountData')}</StyledP>
          <StyledP>{t('privacyPage.informationCollected.usageData')}</StyledP>
          <StyledP>
            {t('privacyPage.informationCollected.cookies')}
            <StyledLink
              href="https://stripe.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('privacyPage.informationCollected.stripePrivacy')}
            </StyledLink>
          </StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.howWeUse.heading')}</StyledH>
          <StyledP>{t('privacyPage.howWeUse.manageAccount')}</StyledP>
          <StyledP>{t('privacyPage.howWeUse.personalizeExperience')}</StyledP>
          <StyledP>{t('privacyPage.howWeUse.preventFraud')}</StyledP>
          <StyledP>{t('privacyPage.howWeUse.legalObligations')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.dataSharing.heading')}</StyledH>
          <StyledP>{t('privacyPage.dataSharing.noSale')}</StyledP>
          <StyledP>{t('privacyPage.dataSharing.thirdParties')}</StyledP>
          <StyledP>
            {t('privacyPage.dataSharing.cloudflare')}
            <StyledLink
              href="https://www.cloudflare.com/privacypolicy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('privacyPage.dataSharing.cloudflareLink')}
            </StyledLink>
          </StyledP>
          <StyledP>{t('privacyPage.dataSharing.legalRequests')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.dataRetention.heading')}</StyledH>
          <StyledP>{t('privacyPage.dataRetention.activeAccount')}</StyledP>
          <StyledP>{t('privacyPage.dataRetention.deletionOnRequest')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.yourRights.heading')}</StyledH>
          <StyledP>{t('privacyPage.yourRights.generalText')}</StyledP>
          <StyledP>{t('privacyPage.yourRights.gdpr')}</StyledP>
          <StyledP>{t('privacyPage.yourRights.ccpa')}</StyledP>
          <StyledP>{t('privacyPage.yourRights.pipeda')}</StyledP>
          <StyledP>
            {t('privacyPage.yourRights.contactText')}{' '}
            <StyledLink href={SupportEmailMailTo}>
              {SupportEmail}
            </StyledLink>
          </StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.security.heading')}</StyledH>
          <StyledP>{t('privacyPage.security.protectionMeasures')}</StyledP>
          <StyledP>{t('privacyPage.security.noSystemIs100Percent')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.internationalTransfers.heading')}</StyledH>
          <StyledP>{t('privacyPage.internationalTransfers.text')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.policyChanges.heading')}</StyledH>
          <StyledP>{t('privacyPage.policyChanges.reservedRight')}</StyledP>
          <StyledP>{t('privacyPage.policyChanges.announcement')}</StyledP>
        </Section>
        <Section>
          <StyledH>{t('privacyPage.contact.heading')}</StyledH>
          <StyledP>
            {t('privacyPage.contact.text')}{' '}
            <StyledLink href={SupportEmailMailTo}>
              {SupportEmail}
            </StyledLink>
          </StyledP>
        </Section>
      </PrivacyContainer>
    </PageContentComponent>
  );
};

export default PrivacyPage;
